import styled from 'styled-components';
import './typography.theme';
import { typographyMixin, TypographyProps } from './typographyMixin';
import { defaultProps } from './props';

/** `Typography` is responsible for styling the text according to the designs */
export const Typography = styled.span<TypographyProps>`
  ${typographyMixin}
`;

Typography.defaultProps = defaultProps;
